import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { MatDialog } from '@angular/material/dialog';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router ,ActivatedRoute} from '@angular/router';
import { Auth } from 'aws-amplify';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';


@Component({
  selector: 'app-backoffice-transactions',
  templateUrl: './transactionDetail.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class TransaccionDetailComponent implements OnInit {
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  canAccess = false;

  // Propiedades para manejar transacciones
  transactionDetail: any[] = [];
  paginationToken: string | null = null;
  hasMoreTransactions: boolean = true;
  loadingTransactions: boolean = false;
  filteredCounts: { transactionList: number } = { transactionList: 0 };
  filterTransactions: any[] = [];
  objectKeys = Object.keys;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }
    const id = this.route.snapshot.queryParamMap.get('id');
    if (id) {
      this.getTransactionDetail(id);
    }
  }

  async getTransactionDetail(id: string): Promise<void> {
    try {
      this.loadingTransactions = true;

      const response = await this.lambda.getLambdaFunction('lambda', '/get/transfers', {
        queryStringParameters: {
          id: id
        }
      });
  
      if (response?.data?.length) {
        this.transactionDetail = response.data; // o solo el primer ítem si esperas uno
      } else {
        console.warn('Transacción no encontrada');
      }
    }
  catch (error: any) {
    console.error('Error al obtener transacción:', error);
  } finally {
    this.loadingTransactions = false;
  }
}
   
}